// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Character detail: visual canvas + compact profile sidebar */

.character-detail-content {
  --character-panel: var(--color-bg-canvas-surface);
  --character-subtle: var(--color-bg-user-bubble);
  --character-danger: #dc2626;
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 28px 32px 40px;
  background: var(--color-bg-root);
  color: var(--color-text-primary);
}

.character-detail-shell {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
}

.character-detail-loading,
.character-detail-error-page {
  display: flex;
  min-height: 60vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 48px 24px;
  color: var(--color-text-secondary);
  font-size: 13px;
}

.character-detail-topbar {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
  margin-bottom: 18px;
  color: var(--color-text-secondary);
  font-size: 12px;
}

.character-detail-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 7px 5px 5px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text-secondary);
  font: inherit;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease, color 120ms ease;
}

.character-detail-back:hover,
.character-detail-back:focus-visible {
  border-color: var(--color-border-input);
  background: var(--character-subtle);
  color: var(--color-text-primary);
  outline: none;
}

.character-detail-breadcrumb-separator {
  opacity: 0.45;
}

.character-detail-breadcrumb-current {
  min-width: 0;
  overflow: hidden;
  color: var(--color-text-primary);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.character-detail-error {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 14px;
  padding: 9px 12px;
  border: 1px solid var(--color-status-error-border, rgba(220, 38, 38, 0.35));
  border-radius: 5px;
  background: var(--color-status-error-tint, rgba(220, 38, 38, 0.08));
  color: var(--color-status-error-text, #b91c1c);
  font-size: 12px;
}

.character-detail-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 372px);
  align-items: start;
  gap: 18px;
}

/* Visual canvas */
.character-detail-main {
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: var(--character-panel);
}

.character-detail-visual-header {
  display: flex;
  min-height: 65px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 11px 14px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--color-border-input);
}

.character-detail-section-kicker,
.character-detail-label,
.character-voice-preview-heading {
  color: var(--color-text-secondary);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.07em;
  line-height: 1.3;
  text-transform: uppercase;
}

.character-detail-visual-hint {
  margin: 3px 0 0;
  color: var(--color-text-secondary);
  font-size: 12px;
  line-height: 1.4;
}

.character-detail-change-image,
.character-detail-save-btn,
.character-detail-cancel-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 29px;
  padding: 5px 9px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
}

.character-detail-change-image:hover,
.character-detail-save-btn:hover,
.character-detail-cancel-btn:hover {
  border-color: var(--color-text-secondary);
  background: var(--character-subtle);
}

.character-detail-change-image:focus-visible,
.character-detail-save-btn:focus-visible,
.character-detail-cancel-btn:focus-visible,
.character-detail-inline-btn:focus-visible,
.character-detail-edit-button:focus-visible,
.character-detail-edit-link:focus-visible,
.character-detail-delete-trigger:focus-visible,
.character-detail-delete-btn:focus-visible,
.character-voice-play-btn:focus-visible {
  outline: 2px solid var(--color-focus-ring);
  outline-offset: 1px;
}

.character-detail-hero {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 4 / 5;
  max-height: calc(100vh - 178px);
  min-height: 480px;
  overflow: hidden;
  padding: 0;
  border: 0;
  border-radius: 0;
  background:
    linear-gradient(135deg, transparent 0 49.8%, var(--color-border-input) 49.9% 50.1%, transparent 50.2%) center / 28px 28px,
    var(--color-bg-canvas-frame);
  color: var(--color-text-primary);
  cursor: pointer;
  font-family: inherit;
}

.character-detail-hero--static,
.character-detail-hero:disabled {
  cursor: default;
  opacity: 1;
}

.character-detail-hero:focus-visible {
  outline: 2px solid var(--color-focus-ring);
  outline-offset: -3px;
}

.character-detail-hero-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  background: var(--color-bg-canvas-frame);
  transition: transform 180ms cubic-bezier(0.2, 0.7, 0.2, 1), filter 180ms ease;
}

.character-detail-hero:not(.character-detail-hero--static):hover .character-detail-hero-img {
  transform: scale(1.006);
  filter: brightness(0.82);
}

.character-detail-hero-placeholder {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: var(--color-text-secondary);
  font-size: 12px;
}

.character-detail-hero-placeholder svg {
  opacity: 0.28;
}

.character-detail-hero-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.12);
  opacity: 0;
  transition: opacity 150ms ease;
}

.character-detail-hero:hover .character-detail-hero-overlay,
.character-detail-hero:focus-visible .character-detail-hero-overlay {
  opacity: 1;
}

.character-detail-hero-overlay-action {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 10px;
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 5px;
  background: rgba(8, 10, 14, 0.76);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  backdrop-filter: blur(8px);
  transform: translateY(4px);
  transition: transform 150ms ease;
}

.character-detail-hero:hover .character-detail-hero-overlay-action,
.character-detail-hero:focus-visible .character-detail-hero-overlay-action {
  transform: translateY(0);
}

/* Right profile sidebar */
.character-detail-sidebar {
  position: sticky;
  top: 0;
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: var(--character-panel);
}

.character-detail-identity {
  padding: 16px;
  border-bottom: 1px solid var(--color-border-input);
}

.character-detail-identity-meta,
.character-detail-field-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.character-detail-source-badge {
  padding: 3px 6px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--character-subtle);
  color: var(--color-text-secondary);
  font-size: 10px;
  font-weight: 600;
}

.character-detail-name-field {
  margin-top: 12px;
}

.character-detail-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.character-detail-name {
  min-width: 0;
  margin: 0;
  color: var(--color-text-primary);
  font-size: 22px;
  font-weight: 650;
  letter-spacing: -0.035em;
  line-height: 1.18;
  overflow-wrap: anywhere;
}

.character-detail-edit-button,
.character-detail-edit-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text-secondary);
  font-family: inherit;
  cursor: pointer;
  transition: background 120ms ease, color 120ms ease;
}

.character-detail-edit-button {
  flex: 0 0 auto;
  opacity: 0.65;
}

.character-detail-edit-link {
  padding: 3px 5px;
  font-size: 10px;
  font-weight: 600;
}

.character-detail-edit-button:hover,
.character-detail-edit-link:hover {
  background: var(--character-subtle);
  color: var(--color-text-primary);
}

.character-detail-panel-section {
  padding: 15px 16px 16px;
  border-bottom: 1px solid var(--color-border-input);
}

.character-detail-label {
  display: block;
  margin: 0;
}

.character-detail-text {
  margin: 8px 0 0;
  color: var(--color-text-primary);
  font-size: 12px;
  line-height: 1.62;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.character-detail-text--empty {
  color: var(--color-text-secondary);
  font-style: italic;
}

/* Inline editing */
.character-detail-inline-edit {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 6px;
}

.character-detail-inline-edit--vertical {
  align-items: stretch;
  flex-direction: column;
  margin-top: 8px;
}

.character-detail-inline-input,
.character-detail-textarea {
  min-width: 0;
  box-sizing: border-box;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-family: inherit;
  font-size: 12px;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}

.character-detail-inline-input {
  flex: 1 1;
  height: 32px;
  padding: 6px 9px;
}

.character-detail-name-input {
  font-size: 14px;
  font-weight: 600;
}

.character-detail-textarea {
  width: 100%;
  min-height: 104px;
  padding: 8px 9px;
  line-height: 1.55;
  resize: vertical;
}

.character-detail-inline-input:focus,
.character-detail-textarea:focus {
  border-color: var(--color-text-secondary);
  box-shadow: 0 0 0 2px var(--color-focus-ring);
  outline: none;
}

.character-detail-inline-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.character-detail-inline-btn {
  display: inline-flex;
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  cursor: pointer;
}

.character-detail-inline-btn:hover {
  border-color: var(--color-text-secondary);
  color: var(--color-text-primary);
}

.character-detail-save-btn:disabled,
.character-detail-inline-btn:disabled,
.character-detail-delete-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

/* Voice */
.character-voice-preview-heading {
  display: flex;
  align-items: center;
  gap: 6px;
}

.character-voice-preview-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.character-voice-play-btn {
  display: flex;
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid var(--color-border-input);
  border-radius: 50%;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
}

.character-voice-play-btn:hover:not(:disabled) {
  border-color: var(--color-text-secondary);
  background: var(--character-subtle);
}

.character-voice-play-btn:disabled {
  cursor: not-allowed;
  opacity: 0.35;
}

.character-voice-preview-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.character-voice-current-name {
  overflow: hidden;
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.character-voice-preview-status {
  color: var(--color-text-secondary);
  font-size: 10px;
}

/* Keywords */
.character-detail-keywords {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 9px;
}

.character-detail-keyword {
  padding: 3px 7px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--character-subtle);
  color: var(--color-text-secondary);
  font-size: 10px;
  font-weight: 500;
}

/* Danger zone */
.character-detail-danger-zone {
  padding: 11px 16px;
  background: color-mix(in srgb, var(--character-danger) 3%, transparent);
}

.character-detail-delete-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
  border: 0;
  background: transparent;
  color: var(--character-danger);
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

.character-detail-delete-trigger:hover {
  text-decoration: underline;
}

.character-detail-delete-confirm {
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: var(--color-text-primary);
  font-size: 11px;
}

.character-detail-delete-confirm strong,
.character-detail-delete-confirm span {
  display: block;
}

.character-detail-delete-confirm span {
  margin-top: 2px;
  color: var(--color-text-secondary);
}

.character-detail-delete-actions {
  display: flex;
  gap: 6px;
}

.character-detail-delete-btn {
  min-height: 29px;
  padding: 5px 10px;
  border: 1px solid var(--character-danger);
  border-radius: 4px;
  background: var(--character-danger);
  color: #fff;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

/* Asset picker modal */
.character-asset-picker {
  max-width: 540px;
  max-height: 80vh;
  overflow-y: auto;
}

.character-asset-picker-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(92px, 1fr));
  gap: 7px;
  margin: 16px 0;
}

.character-asset-picker-item {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px;
  border: 1px solid transparent;
  border-radius: 5px;
  cursor: pointer;
  transition: border-color 120ms ease, background 120ms ease;
}

.character-asset-picker-item:hover {
  background: var(--color-bg-input);
}

.character-asset-picker-item--selected {
  border-color: var(--color-text-primary);
  background: var(--color-bg-input);
}

.character-asset-picker-thumb {
  display: flex;
  width: 66px;
  height: 66px;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border-input);
  border-radius: 5px;
  background: var(--color-bg-canvas-frame);
  color: var(--color-text-secondary);
}

.character-asset-picker-thumb--none {
  opacity: 0.55;
}

.character-asset-picker-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.character-asset-picker-name {
  width: 100%;
  overflow: hidden;
  color: var(--color-text-secondary);
  font-size: 10px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.spin {
  animation: spin 0.8s linear infinite;
}

@media (max-width: 900px) {
  .character-detail-content {
    padding: 22px 20px 36px;
  }

  .character-detail-layout {
    grid-template-columns: minmax(0, 1fr) 320px;
  }
}

@media (max-width: 760px) {
  .character-detail-content {
    padding: 16px 14px 28px;
  }

  .character-detail-topbar {
    margin-bottom: 12px;
  }

  .character-detail-layout {
    display: flex;
    flex-direction: column;
  }

  .character-detail-main,
  .character-detail-sidebar {
    width: 100%;
  }

  .character-detail-sidebar {
    position: static;
  }

  .character-detail-hero {
    min-height: 0;
    max-height: none;
    aspect-ratio: 4 / 5;
  }
}

@media (max-width: 480px) {
  .character-detail-visual-header {
    align-items: flex-start;
  }

  .character-detail-visual-hint {
    max-width: 190px;
  }

  .character-detail-change-image {
    padding-inline: 7px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .character-detail-hero-img,
  .character-detail-hero-overlay,
  .character-detail-hero-overlay-action {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/CharacterDetailPage.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,4EAA4E;AAC9E;;AAEA;;EAEE,uCAAuC;EACvC,mCAAmC;EACnC,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,2EAA2E;EAC3E,kBAAkB;EAClB,mEAAmE;EACnE,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,kBAAkB;EAClB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;;;EAGE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;;EAGE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;;;;;;;;;EASE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB;;gCAE8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,6EAA6E;AAC/E;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,UAAU;EACV,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kDAAkD;AACpD;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;EACpB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,yCAAyC;EACzC,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,mCAAmC;EACnC,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;AACF","sourcesContent":["/* Character detail: visual canvas + compact profile sidebar */\n\n.character-detail-content {\n  --character-panel: var(--color-bg-canvas-surface);\n  --character-subtle: var(--color-bg-user-bubble);\n  --character-danger: #dc2626;\n  height: 100%;\n  min-height: 0;\n  overflow-y: auto;\n  box-sizing: border-box;\n  padding: 28px 32px 40px;\n  background: var(--color-bg-root);\n  color: var(--color-text-primary);\n}\n\n.character-detail-shell {\n  width: 100%;\n  max-width: 1180px;\n  margin: 0 auto;\n}\n\n.character-detail-loading,\n.character-detail-error-page {\n  display: flex;\n  min-height: 60vh;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 48px 24px;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n}\n\n.character-detail-topbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 32px;\n  margin-bottom: 18px;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n}\n\n.character-detail-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 7px 5px 5px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font: inherit;\n  cursor: pointer;\n  transition: background 120ms ease, border-color 120ms ease, color 120ms ease;\n}\n\n.character-detail-back:hover,\n.character-detail-back:focus-visible {\n  border-color: var(--color-border-input);\n  background: var(--character-subtle);\n  color: var(--color-text-primary);\n  outline: none;\n}\n\n.character-detail-breadcrumb-separator {\n  opacity: 0.45;\n}\n\n.character-detail-breadcrumb-current {\n  min-width: 0;\n  overflow: hidden;\n  color: var(--color-text-primary);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.character-detail-error {\n  width: 100%;\n  box-sizing: border-box;\n  margin-bottom: 14px;\n  padding: 9px 12px;\n  border: 1px solid var(--color-status-error-border, rgba(220, 38, 38, 0.35));\n  border-radius: 5px;\n  background: var(--color-status-error-tint, rgba(220, 38, 38, 0.08));\n  color: var(--color-status-error-text, #b91c1c);\n  font-size: 12px;\n}\n\n.character-detail-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(320px, 372px);\n  align-items: start;\n  gap: 18px;\n}\n\n/* Visual canvas */\n.character-detail-main {\n  min-width: 0;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: var(--character-panel);\n}\n\n.character-detail-visual-header {\n  display: flex;\n  min-height: 65px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 11px 14px;\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.character-detail-section-kicker,\n.character-detail-label,\n.character-voice-preview-heading {\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  line-height: 1.3;\n  text-transform: uppercase;\n}\n\n.character-detail-visual-hint {\n  margin: 3px 0 0;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.character-detail-change-image,\n.character-detail-save-btn,\n.character-detail-cancel-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 29px;\n  padding: 5px 9px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-family: inherit;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 120ms ease, border-color 120ms ease;\n}\n\n.character-detail-change-image:hover,\n.character-detail-save-btn:hover,\n.character-detail-cancel-btn:hover {\n  border-color: var(--color-text-secondary);\n  background: var(--character-subtle);\n}\n\n.character-detail-change-image:focus-visible,\n.character-detail-save-btn:focus-visible,\n.character-detail-cancel-btn:focus-visible,\n.character-detail-inline-btn:focus-visible,\n.character-detail-edit-button:focus-visible,\n.character-detail-edit-link:focus-visible,\n.character-detail-delete-trigger:focus-visible,\n.character-detail-delete-btn:focus-visible,\n.character-voice-play-btn:focus-visible {\n  outline: 2px solid var(--color-focus-ring);\n  outline-offset: 1px;\n}\n\n.character-detail-hero {\n  position: relative;\n  display: block;\n  width: 100%;\n  aspect-ratio: 4 / 5;\n  max-height: calc(100vh - 178px);\n  min-height: 480px;\n  overflow: hidden;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background:\n    linear-gradient(135deg, transparent 0 49.8%, var(--color-border-input) 49.9% 50.1%, transparent 50.2%) center / 28px 28px,\n    var(--color-bg-canvas-frame);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.character-detail-hero--static,\n.character-detail-hero:disabled {\n  cursor: default;\n  opacity: 1;\n}\n\n.character-detail-hero:focus-visible {\n  outline: 2px solid var(--color-focus-ring);\n  outline-offset: -3px;\n}\n\n.character-detail-hero-img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: center;\n  background: var(--color-bg-canvas-frame);\n  transition: transform 180ms cubic-bezier(0.2, 0.7, 0.2, 1), filter 180ms ease;\n}\n\n.character-detail-hero:not(.character-detail-hero--static):hover .character-detail-hero-img {\n  transform: scale(1.006);\n  filter: brightness(0.82);\n}\n\n.character-detail-hero-placeholder {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n}\n\n.character-detail-hero-placeholder svg {\n  opacity: 0.28;\n}\n\n.character-detail-hero-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.12);\n  opacity: 0;\n  transition: opacity 150ms ease;\n}\n\n.character-detail-hero:hover .character-detail-hero-overlay,\n.character-detail-hero:focus-visible .character-detail-hero-overlay {\n  opacity: 1;\n}\n\n.character-detail-hero-overlay-action {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 10px;\n  border: 1px solid rgba(255, 255, 255, 0.32);\n  border-radius: 5px;\n  background: rgba(8, 10, 14, 0.76);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 600;\n  backdrop-filter: blur(8px);\n  transform: translateY(4px);\n  transition: transform 150ms ease;\n}\n\n.character-detail-hero:hover .character-detail-hero-overlay-action,\n.character-detail-hero:focus-visible .character-detail-hero-overlay-action {\n  transform: translateY(0);\n}\n\n/* Right profile sidebar */\n.character-detail-sidebar {\n  position: sticky;\n  top: 0;\n  min-width: 0;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: var(--character-panel);\n}\n\n.character-detail-identity {\n  padding: 16px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.character-detail-identity-meta,\n.character-detail-field-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.character-detail-source-badge {\n  padding: 3px 6px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--character-subtle);\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.character-detail-name-field {\n  margin-top: 12px;\n}\n\n.character-detail-name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.character-detail-name {\n  min-width: 0;\n  margin: 0;\n  color: var(--color-text-primary);\n  font-size: 22px;\n  font-weight: 650;\n  letter-spacing: -0.035em;\n  line-height: 1.18;\n  overflow-wrap: anywhere;\n}\n\n.character-detail-edit-button,\n.character-detail-edit-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 4px;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 120ms ease, color 120ms ease;\n}\n\n.character-detail-edit-button {\n  flex: 0 0 auto;\n  opacity: 0.65;\n}\n\n.character-detail-edit-link {\n  padding: 3px 5px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.character-detail-edit-button:hover,\n.character-detail-edit-link:hover {\n  background: var(--character-subtle);\n  color: var(--color-text-primary);\n}\n\n.character-detail-panel-section {\n  padding: 15px 16px 16px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.character-detail-label {\n  display: block;\n  margin: 0;\n}\n\n.character-detail-text {\n  margin: 8px 0 0;\n  color: var(--color-text-primary);\n  font-size: 12px;\n  line-height: 1.62;\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n}\n\n.character-detail-text--empty {\n  color: var(--color-text-secondary);\n  font-style: italic;\n}\n\n/* Inline editing */\n.character-detail-inline-edit {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 6px;\n}\n\n.character-detail-inline-edit--vertical {\n  align-items: stretch;\n  flex-direction: column;\n  margin-top: 8px;\n}\n\n.character-detail-inline-input,\n.character-detail-textarea {\n  min-width: 0;\n  box-sizing: border-box;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-family: inherit;\n  font-size: 12px;\n  transition: border-color 120ms ease, box-shadow 120ms ease;\n}\n\n.character-detail-inline-input {\n  flex: 1;\n  height: 32px;\n  padding: 6px 9px;\n}\n\n.character-detail-name-input {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.character-detail-textarea {\n  width: 100%;\n  min-height: 104px;\n  padding: 8px 9px;\n  line-height: 1.55;\n  resize: vertical;\n}\n\n.character-detail-inline-input:focus,\n.character-detail-textarea:focus {\n  border-color: var(--color-text-secondary);\n  box-shadow: 0 0 0 2px var(--color-focus-ring);\n  outline: none;\n}\n\n.character-detail-inline-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.character-detail-inline-btn {\n  display: inline-flex;\n  width: 30px;\n  height: 30px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n}\n\n.character-detail-inline-btn:hover {\n  border-color: var(--color-text-secondary);\n  color: var(--color-text-primary);\n}\n\n.character-detail-save-btn:disabled,\n.character-detail-inline-btn:disabled,\n.character-detail-delete-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n/* Voice */\n.character-voice-preview-heading {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.character-voice-preview-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.character-voice-play-btn {\n  display: flex;\n  width: 30px;\n  height: 30px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid var(--color-border-input);\n  border-radius: 50%;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  transition: background 120ms ease, border-color 120ms ease;\n}\n\n.character-voice-play-btn:hover:not(:disabled) {\n  border-color: var(--color-text-secondary);\n  background: var(--character-subtle);\n}\n\n.character-voice-play-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.35;\n}\n\n.character-voice-preview-copy {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.character-voice-current-name {\n  overflow: hidden;\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.character-voice-preview-status {\n  color: var(--color-text-secondary);\n  font-size: 10px;\n}\n\n/* Keywords */\n.character-detail-keywords {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin-top: 9px;\n}\n\n.character-detail-keyword {\n  padding: 3px 7px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--character-subtle);\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  font-weight: 500;\n}\n\n/* Danger zone */\n.character-detail-danger-zone {\n  padding: 11px 16px;\n  background: color-mix(in srgb, var(--character-danger) 3%, transparent);\n}\n\n.character-detail-delete-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 0;\n  border: 0;\n  background: transparent;\n  color: var(--character-danger);\n  font-family: inherit;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.character-detail-delete-trigger:hover {\n  text-decoration: underline;\n}\n\n.character-detail-delete-confirm {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  color: var(--color-text-primary);\n  font-size: 11px;\n}\n\n.character-detail-delete-confirm strong,\n.character-detail-delete-confirm span {\n  display: block;\n}\n\n.character-detail-delete-confirm span {\n  margin-top: 2px;\n  color: var(--color-text-secondary);\n}\n\n.character-detail-delete-actions {\n  display: flex;\n  gap: 6px;\n}\n\n.character-detail-delete-btn {\n  min-height: 29px;\n  padding: 5px 10px;\n  border: 1px solid var(--character-danger);\n  border-radius: 4px;\n  background: var(--character-danger);\n  color: #fff;\n  font-family: inherit;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n/* Asset picker modal */\n.character-asset-picker {\n  max-width: 540px;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.character-asset-picker-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(92px, 1fr));\n  gap: 7px;\n  margin: 16px 0;\n}\n\n.character-asset-picker-item {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 8px;\n  border: 1px solid transparent;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: border-color 120ms ease, background 120ms ease;\n}\n\n.character-asset-picker-item:hover {\n  background: var(--color-bg-input);\n}\n\n.character-asset-picker-item--selected {\n  border-color: var(--color-text-primary);\n  background: var(--color-bg-input);\n}\n\n.character-asset-picker-thumb {\n  display: flex;\n  width: 66px;\n  height: 66px;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--color-border-input);\n  border-radius: 5px;\n  background: var(--color-bg-canvas-frame);\n  color: var(--color-text-secondary);\n}\n\n.character-asset-picker-thumb--none {\n  opacity: 0.55;\n}\n\n.character-asset-picker-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.character-asset-picker-name {\n  width: 100%;\n  overflow: hidden;\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.spin {\n  animation: spin 0.8s linear infinite;\n}\n\n@media (max-width: 900px) {\n  .character-detail-content {\n    padding: 22px 20px 36px;\n  }\n\n  .character-detail-layout {\n    grid-template-columns: minmax(0, 1fr) 320px;\n  }\n}\n\n@media (max-width: 760px) {\n  .character-detail-content {\n    padding: 16px 14px 28px;\n  }\n\n  .character-detail-topbar {\n    margin-bottom: 12px;\n  }\n\n  .character-detail-layout {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .character-detail-main,\n  .character-detail-sidebar {\n    width: 100%;\n  }\n\n  .character-detail-sidebar {\n    position: static;\n  }\n\n  .character-detail-hero {\n    min-height: 0;\n    max-height: none;\n    aspect-ratio: 4 / 5;\n  }\n}\n\n@media (max-width: 480px) {\n  .character-detail-visual-header {\n    align-items: flex-start;\n  }\n\n  .character-detail-visual-hint {\n    max-width: 190px;\n  }\n\n  .character-detail-change-image {\n    padding-inline: 7px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .character-detail-hero-img,\n  .character-detail-hero-overlay,\n  .character-detail-hero-overlay-action {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
